/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $7f1ab97a393746d0$var$extendStatics = function(d, b) {
    $7f1ab97a393746d0$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $7f1ab97a393746d0$var$extendStatics(d, b);
};
function $7f1ab97a393746d0$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $7f1ab97a393746d0$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $7f1ab97a393746d0$export$18ce0697a983be9b = function() {
    $7f1ab97a393746d0$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7f1ab97a393746d0$export$18ce0697a983be9b.apply(this, arguments);
};
function $7f1ab97a393746d0$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $7f1ab97a393746d0$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $7f1ab97a393746d0$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $7f1ab97a393746d0$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $7f1ab97a393746d0$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $7f1ab97a393746d0$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $7f1ab97a393746d0$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $7f1ab97a393746d0$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $7f1ab97a393746d0$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $7f1ab97a393746d0$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $7f1ab97a393746d0$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $7f1ab97a393746d0$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $7f1ab97a393746d0$export$45d3717a4c69092e(o, m, p);
}
function $7f1ab97a393746d0$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $7f1ab97a393746d0$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $7f1ab97a393746d0$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($7f1ab97a393746d0$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $7f1ab97a393746d0$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $7f1ab97a393746d0$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $7f1ab97a393746d0$export$10c90e4f7922046c(v) {
    return this instanceof $7f1ab97a393746d0$export$10c90e4f7922046c ? (this.v = v, this) : new $7f1ab97a393746d0$export$10c90e4f7922046c(v);
}
function $7f1ab97a393746d0$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $7f1ab97a393746d0$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $7f1ab97a393746d0$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $7f1ab97a393746d0$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $7f1ab97a393746d0$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $7f1ab97a393746d0$export$19a8beecd37a4c45 === "function" ? $7f1ab97a393746d0$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $7f1ab97a393746d0$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $7f1ab97a393746d0$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $7f1ab97a393746d0$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7f1ab97a393746d0$export$45d3717a4c69092e(result, mod, k);
    }
    $7f1ab97a393746d0$var$__setModuleDefault(result, mod);
    return result;
}
function $7f1ab97a393746d0$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $7f1ab97a393746d0$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $7f1ab97a393746d0$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $7f1ab97a393746d0$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $7f1ab97a393746d0$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $7f1ab97a393746d0$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $7f1ab97a393746d0$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $7f1ab97a393746d0$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $7f1ab97a393746d0$export$2e2bcd8739ae039 = {
    __extends: $7f1ab97a393746d0$export$a8ba968b8961cb8a,
    __assign: $7f1ab97a393746d0$export$18ce0697a983be9b,
    __rest: $7f1ab97a393746d0$export$3c9a16f847548506,
    __decorate: $7f1ab97a393746d0$export$29e00dfd3077644b,
    __param: $7f1ab97a393746d0$export$d5ad3fd78186038f,
    __metadata: $7f1ab97a393746d0$export$f1db080c865becb9,
    __awaiter: $7f1ab97a393746d0$export$1050f835b63b671e,
    __generator: $7f1ab97a393746d0$export$67ebef60e6f28a6,
    __createBinding: $7f1ab97a393746d0$export$45d3717a4c69092e,
    __exportStar: $7f1ab97a393746d0$export$f33643c0debef087,
    __values: $7f1ab97a393746d0$export$19a8beecd37a4c45,
    __read: $7f1ab97a393746d0$export$8d051b38c9118094,
    __spread: $7f1ab97a393746d0$export$afc72e2116322959,
    __spreadArrays: $7f1ab97a393746d0$export$6388937ca91ccae8,
    __spreadArray: $7f1ab97a393746d0$export$1216008129fb82ed,
    __await: $7f1ab97a393746d0$export$10c90e4f7922046c,
    __asyncGenerator: $7f1ab97a393746d0$export$e427f37a30a4de9b,
    __asyncDelegator: $7f1ab97a393746d0$export$bbd80228419bb833,
    __asyncValues: $7f1ab97a393746d0$export$e3b29a3d6162315f,
    __makeTemplateObject: $7f1ab97a393746d0$export$4fb47efe1390b86f,
    __importStar: $7f1ab97a393746d0$export$c21735bcef00d192,
    __importDefault: $7f1ab97a393746d0$export$da59b14a69baef04,
    __classPrivateFieldGet: $7f1ab97a393746d0$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $7f1ab97a393746d0$export$d40a35129aaff81f,
    __classPrivateFieldIn: $7f1ab97a393746d0$export$81fdc39f203e4e04,
    __addDisposableResource: $7f1ab97a393746d0$export$88ac25d8e944e405,
    __disposeResources: $7f1ab97a393746d0$export$8f076105dc360e92
};


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3233927aa82734f9$var$t = window, $3233927aa82734f9$export$b4d10f6001c083c2 = $3233927aa82734f9$var$t.ShadowRoot && (void 0 === $3233927aa82734f9$var$t.ShadyCSS || $3233927aa82734f9$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $3233927aa82734f9$var$s = Symbol(), $3233927aa82734f9$var$n = new WeakMap;
class $3233927aa82734f9$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $3233927aa82734f9$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($3233927aa82734f9$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $3233927aa82734f9$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $3233927aa82734f9$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $3233927aa82734f9$export$8d80f9cac07cdb3 = (t)=>new $3233927aa82734f9$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $3233927aa82734f9$var$s), $3233927aa82734f9$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $3233927aa82734f9$export$505d1e8739bad805(n, t, $3233927aa82734f9$var$s);
}, $3233927aa82734f9$export$2ca4a66ec4cecb90 = (s, n)=>{
    $3233927aa82734f9$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $3233927aa82734f9$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $3233927aa82734f9$export$ee69dfd951e24778 = $3233927aa82734f9$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $3233927aa82734f9$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $27fcf98b67c2a783$var$s;
const $27fcf98b67c2a783$var$e = window, $27fcf98b67c2a783$var$r = $27fcf98b67c2a783$var$e.trustedTypes, $27fcf98b67c2a783$var$h = $27fcf98b67c2a783$var$r ? $27fcf98b67c2a783$var$r.emptyScript : "", $27fcf98b67c2a783$var$o = $27fcf98b67c2a783$var$e.reactiveElementPolyfillSupport, $27fcf98b67c2a783$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $27fcf98b67c2a783$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $27fcf98b67c2a783$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $27fcf98b67c2a783$var$l = {
    attribute: !0,
    type: String,
    converter: $27fcf98b67c2a783$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $27fcf98b67c2a783$export$53a6892c50694894
}, $27fcf98b67c2a783$var$d = "finalized";
class $27fcf98b67c2a783$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $27fcf98b67c2a783$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $27fcf98b67c2a783$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty($27fcf98b67c2a783$var$d)) return !1;
        this[$27fcf98b67c2a783$var$d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $3233927aa82734f9$export$ee69dfd951e24778)(i));
        } else void 0 !== i && s.push((0, $3233927aa82734f9$export$ee69dfd951e24778)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Eu() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $3233927aa82734f9$export$2ca4a66ec4cecb90)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $27fcf98b67c2a783$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $27fcf98b67c2a783$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $27fcf98b67c2a783$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $27fcf98b67c2a783$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$27fcf98b67c2a783$export$c7c07a37856565d[$27fcf98b67c2a783$var$d] = !0, $27fcf98b67c2a783$export$c7c07a37856565d.elementProperties = new Map, $27fcf98b67c2a783$export$c7c07a37856565d.elementStyles = [], $27fcf98b67c2a783$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $27fcf98b67c2a783$var$o || $27fcf98b67c2a783$var$o({
    ReactiveElement: $27fcf98b67c2a783$export$c7c07a37856565d
}), (null !== ($27fcf98b67c2a783$var$s = $27fcf98b67c2a783$var$e.reactiveElementVersions) && void 0 !== $27fcf98b67c2a783$var$s ? $27fcf98b67c2a783$var$s : $27fcf98b67c2a783$var$e.reactiveElementVersions = []).push("1.6.3");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $e5ed8027d647799b$var$t;
const $e5ed8027d647799b$var$i = window, $e5ed8027d647799b$var$s = $e5ed8027d647799b$var$i.trustedTypes, $e5ed8027d647799b$var$e = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e5ed8027d647799b$var$o = "$lit$", $e5ed8027d647799b$var$n = `lit$${(Math.random() + "").slice(9)}$`, $e5ed8027d647799b$var$l = "?" + $e5ed8027d647799b$var$n, $e5ed8027d647799b$var$h = `<${$e5ed8027d647799b$var$l}>`, $e5ed8027d647799b$var$r = document, $e5ed8027d647799b$var$u = ()=>$e5ed8027d647799b$var$r.createComment(""), $e5ed8027d647799b$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e5ed8027d647799b$var$c = Array.isArray, $e5ed8027d647799b$var$v = (t)=>$e5ed8027d647799b$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $e5ed8027d647799b$var$a = "[ 	\n\f\r]", $e5ed8027d647799b$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e5ed8027d647799b$var$_ = /-->/g, $e5ed8027d647799b$var$m = />/g, $e5ed8027d647799b$var$p = RegExp(`>|${$e5ed8027d647799b$var$a}(?:([^\\s"'>=/]+)(${$e5ed8027d647799b$var$a}*=${$e5ed8027d647799b$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e5ed8027d647799b$var$g = /'/g, $e5ed8027d647799b$var$$ = /"/g, $e5ed8027d647799b$var$y = /^(?:script|style|textarea|title)$/i, $e5ed8027d647799b$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e5ed8027d647799b$export$c0bb0b647f701bb5 = $e5ed8027d647799b$var$w(1), $e5ed8027d647799b$export$7ed1367e7fa1ad68 = $e5ed8027d647799b$var$w(2), $e5ed8027d647799b$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e5ed8027d647799b$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e5ed8027d647799b$var$E = new WeakMap, $e5ed8027d647799b$var$C = $e5ed8027d647799b$var$r.createTreeWalker($e5ed8027d647799b$var$r, 129, null, !1);
function $e5ed8027d647799b$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e5ed8027d647799b$var$e ? $e5ed8027d647799b$var$e.createHTML(i) : i;
}
const $e5ed8027d647799b$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $e5ed8027d647799b$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $e5ed8027d647799b$var$f ? "!--" === c[1] ? u = $e5ed8027d647799b$var$_ : void 0 !== c[1] ? u = $e5ed8027d647799b$var$m : void 0 !== c[2] ? ($e5ed8027d647799b$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $e5ed8027d647799b$var$p) : void 0 !== c[3] && (u = $e5ed8027d647799b$var$p) : u === $e5ed8027d647799b$var$p ? ">" === c[0] ? (u = null != l ? l : $e5ed8027d647799b$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $e5ed8027d647799b$var$p : '"' === c[3] ? $e5ed8027d647799b$var$$ : $e5ed8027d647799b$var$g) : u === $e5ed8027d647799b$var$$ || u === $e5ed8027d647799b$var$g ? u = $e5ed8027d647799b$var$p : u === $e5ed8027d647799b$var$_ || u === $e5ed8027d647799b$var$m ? u = $e5ed8027d647799b$var$f : (u = $e5ed8027d647799b$var$p, l = void 0);
        const w = u === $e5ed8027d647799b$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $e5ed8027d647799b$var$f ? s + $e5ed8027d647799b$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $e5ed8027d647799b$var$o + s.slice(v) + $e5ed8027d647799b$var$n + w) : s + $e5ed8027d647799b$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $e5ed8027d647799b$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $e5ed8027d647799b$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $e5ed8027d647799b$var$V(t, i);
        if (this.el = $e5ed8027d647799b$var$N.createElement(a, e), $e5ed8027d647799b$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $e5ed8027d647799b$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($e5ed8027d647799b$var$o) || i.startsWith($e5ed8027d647799b$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $e5ed8027d647799b$var$o).split($e5ed8027d647799b$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $e5ed8027d647799b$var$H : "?" === i[1] ? $e5ed8027d647799b$var$L : "@" === i[1] ? $e5ed8027d647799b$var$z : $e5ed8027d647799b$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($e5ed8027d647799b$var$y.test(h.tagName)) {
                    const t = h.textContent.split($e5ed8027d647799b$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $e5ed8027d647799b$var$u()), $e5ed8027d647799b$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $e5ed8027d647799b$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $e5ed8027d647799b$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($e5ed8027d647799b$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $e5ed8027d647799b$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $e5ed8027d647799b$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e5ed8027d647799b$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $e5ed8027d647799b$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $e5ed8027d647799b$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $e5ed8027d647799b$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $e5ed8027d647799b$var$r).importNode(s, !0);
        $e5ed8027d647799b$var$C.currentNode = o;
        let n = $e5ed8027d647799b$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $e5ed8027d647799b$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $e5ed8027d647799b$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $e5ed8027d647799b$var$C.nextNode(), l++);
        }
        return $e5ed8027d647799b$var$C.currentNode = $e5ed8027d647799b$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e5ed8027d647799b$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e5ed8027d647799b$var$S(this, t, i), $e5ed8027d647799b$var$d(t) ? t === $e5ed8027d647799b$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && this._$AR(), this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee) : t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $e5ed8027d647799b$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && $e5ed8027d647799b$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($e5ed8027d647799b$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $e5ed8027d647799b$var$N.createElement($e5ed8027d647799b$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $e5ed8027d647799b$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e5ed8027d647799b$var$E.get(t.strings);
        return void 0 === i && $e5ed8027d647799b$var$E.set(t.strings, i = new $e5ed8027d647799b$var$N(t)), i;
    }
    T(t) {
        $e5ed8027d647799b$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $e5ed8027d647799b$var$R(this.k($e5ed8027d647799b$var$u()), this.k($e5ed8027d647799b$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $e5ed8027d647799b$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $e5ed8027d647799b$var$S(this, t, i, 0), n = !$e5ed8027d647799b$var$d(t) || t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $e5ed8027d647799b$var$S(this, e[s + l], i, l), h === $e5ed8027d647799b$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$e5ed8027d647799b$var$d(h) || h !== this._$AH[l]), h === $e5ed8027d647799b$export$45b790e32b2810ee ? t = $e5ed8027d647799b$export$45b790e32b2810ee : t !== $e5ed8027d647799b$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $e5ed8027d647799b$var$H extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e5ed8027d647799b$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $e5ed8027d647799b$var$I = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.emptyScript : "";
class $e5ed8027d647799b$var$L extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $e5ed8027d647799b$var$I) : this.element.removeAttribute(this.name);
    }
}
class $e5ed8027d647799b$var$z extends $e5ed8027d647799b$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $e5ed8027d647799b$var$S(this, t, i, 0)) && void 0 !== s ? s : $e5ed8027d647799b$export$45b790e32b2810ee) === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $e5ed8027d647799b$export$45b790e32b2810ee && e !== $e5ed8027d647799b$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $e5ed8027d647799b$export$45b790e32b2810ee && (e === $e5ed8027d647799b$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e5ed8027d647799b$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e5ed8027d647799b$var$S(this, t);
    }
}
const $e5ed8027d647799b$export$8613d1ca9052b22e = {
    O: $e5ed8027d647799b$var$o,
    P: $e5ed8027d647799b$var$n,
    A: $e5ed8027d647799b$var$l,
    C: 1,
    M: $e5ed8027d647799b$var$V,
    L: $e5ed8027d647799b$var$M,
    R: $e5ed8027d647799b$var$v,
    D: $e5ed8027d647799b$var$S,
    I: $e5ed8027d647799b$var$R,
    V: $e5ed8027d647799b$var$k,
    H: $e5ed8027d647799b$var$L,
    N: $e5ed8027d647799b$var$z,
    U: $e5ed8027d647799b$var$H,
    F: $e5ed8027d647799b$var$Z
}, $e5ed8027d647799b$var$B = $e5ed8027d647799b$var$i.litHtmlPolyfillSupport;
null == $e5ed8027d647799b$var$B || $e5ed8027d647799b$var$B($e5ed8027d647799b$var$N, $e5ed8027d647799b$var$R), (null !== ($e5ed8027d647799b$var$t = $e5ed8027d647799b$var$i.litHtmlVersions) && void 0 !== $e5ed8027d647799b$var$t ? $e5ed8027d647799b$var$t : $e5ed8027d647799b$var$i.litHtmlVersions = []).push("2.8.0");
const $e5ed8027d647799b$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $e5ed8027d647799b$var$R(i.insertBefore($e5ed8027d647799b$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $fe586ba0757c37f7$var$l, $fe586ba0757c37f7$var$o;
const $fe586ba0757c37f7$export$8bf27daf9e8907c9 = (0, $27fcf98b67c2a783$export$c7c07a37856565d);
class $fe586ba0757c37f7$export$3f2f9f5909897157 extends (0, $27fcf98b67c2a783$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $e5ed8027d647799b$export$9c068ae9cc5db4e8;
    }
}
$fe586ba0757c37f7$export$3f2f9f5909897157.finalized = !0, $fe586ba0757c37f7$export$3f2f9f5909897157._$litElement$ = !0, null === ($fe586ba0757c37f7$var$l = globalThis.litElementHydrateSupport) || void 0 === $fe586ba0757c37f7$var$l || $fe586ba0757c37f7$var$l.call(globalThis, {
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$var$n = globalThis.litElementPolyfillSupport;
null == $fe586ba0757c37f7$var$n || $fe586ba0757c37f7$var$n({
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($fe586ba0757c37f7$var$o = globalThis.litElementVersions) && void 0 !== $fe586ba0757c37f7$var$o ? $fe586ba0757c37f7$var$o : globalThis.litElementVersions = []).push("3.3.3");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $650ed036964a13b8$export$6acf61af03e62db = !1;





/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3baabda811939da5$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $3baabda811939da5$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $3baabda811939da5$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0e5c059fc79abe53$export$56cc687933817664 = (0, $3baabda811939da5$export$99b43ad1ed32e735)(class extends (0, $3baabda811939da5$export$befdefbdce210f91) {
    constructor(t){
        var i;
        if (super(t), t.type !== (0, $3baabda811939da5$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || (null === (i = t.strings) || void 0 === i ? void 0 : i.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((i)=>t[i]).join(" ") + " ";
    }
    update(i, [s]) {
        var r, o;
        if (void 0 === this.it) {
            this.it = new Set, void 0 !== i.strings && (this.nt = new Set(i.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !(null === (r = this.nt) || void 0 === r ? void 0 : r.has(t)) && this.it.add(t);
            return this.render(s);
        }
        const e = i.element.classList;
        this.it.forEach((t)=>{
            t in s || (e.remove(t), this.it.delete(t));
        });
        for(const t in s){
            const i = !!s[t];
            i === this.it.has(t) || (null === (o = this.nt) || void 0 === o ? void 0 : o.has(t)) || (i ? (e.add(t), this.it.add(t)) : (e.remove(t), this.it.delete(t)));
        }
        return 0, $e5ed8027d647799b$export$9c068ae9cc5db4e8;
    }
});


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $07706bf0c990b886$export$da64fc29f17f9d0e = (e)=>(n)=>"function" == typeof n ? ((e, n)=>(customElements.define(e, n), n))(e, n) : ((e, n)=>{
            const { kind: t, elements: s } = n;
            return {
                kind: t,
                elements: s,
                finisher (n) {
                    customElements.define(e, n);
                }
            };
        })(e, n);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b2fdcbe153c88f81$var$i = (i, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, i);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, i);
        }
    }, $b2fdcbe153c88f81$var$e = (i, e, n)=>{
    e.constructor.createProperty(n, i);
};
function $b2fdcbe153c88f81$export$d541bacb2bda4494(n) {
    return (t, o)=>void 0 !== o ? $b2fdcbe153c88f81$var$e(n, t, o) : $b2fdcbe153c88f81$var$i(n, t);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $7162e77b40ffab5c$export$ca000e230c0caa3e(t) {
    return (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        ...t,
        state: !0
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $15c76e2f7983b497$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $15c76e2f7983b497$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $15c76e2f7983b497$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $e5c3d47edfef3b02$export$b2b799818fbabcf3(e) {
    return (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        finisher: (r, t)=>{
            Object.assign(r.prototype[t], e);
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $10a410638b7df95b$export$2fa187e846a241c4(i, n) {
    return (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        descriptor: (o)=>{
            const t = {
                get () {
                    var o, n;
                    return null !== (n = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== n ? n : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (n) {
                const n = "symbol" == typeof o ? Symbol() : "__" + o;
                t.get = function() {
                    var o, t;
                    return void 0 === this[n] && (this[n] = null !== (t = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== t ? t : null), this[n];
                };
            }
            return t;
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $24ba95ebfbdcf6b8$export$dcd0d083aa86c355(e) {
    return (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                get () {
                    var r, o;
                    return null !== (o = null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelectorAll(e)) && void 0 !== o ? o : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $1f45ba04a1effcd1$export$163dfc35cc43f240(e) {
    return (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                async get () {
                    var r;
                    return await this.updateComplete, null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelector(e);
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $43ca3aec390b0561$var$n;
const $43ca3aec390b0561$var$e = null != (null === ($43ca3aec390b0561$var$n = window.HTMLSlotElement) || void 0 === $43ca3aec390b0561$var$n ? void 0 : $43ca3aec390b0561$var$n.prototype.assignedElements) ? (o, n)=>o.assignedElements(n) : (o, n)=>o.assignedNodes(n).filter((o)=>o.nodeType === Node.ELEMENT_NODE);
function $43ca3aec390b0561$export$4682af2d9ee91415(n) {
    const { slot: l, selector: t } = null != n ? n : {};
    return (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        descriptor: (o)=>({
                get () {
                    var o;
                    const r = "slot" + (l ? `[name=${l}]` : ":not([name])"), i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r), s = null != i ? $43ca3aec390b0561$var$e(i, n) : [];
                    return t ? s.filter((o)=>o.matches(t)) : s;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $965e44d5bf066bc5$export$1bdbe53f9df1b8(o, n, r) {
    let l, s = o;
    return "object" == typeof o ? (s = o.slot, l = o) : l = {
        flatten: n
    }, r ? (0, $43ca3aec390b0561$export$4682af2d9ee91415)({
        slot: s,
        flatten: n,
        selector: r
    }) : (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        descriptor: (e)=>({
                get () {
                    var e, t;
                    const o = "slot" + (s ? `[name=${s}]` : ":not([name])"), n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
                    return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




let $e91f56086727f83c$export$148c46df640f7a93 = class LitTypewriter extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    static #_ = (()=>{
        this.styles = (0, $3233927aa82734f9$export$dbf350e5966cf602)`
    :host {
      display: inline;

      color: var(--typewriter-color);
      font-family: var(--typewriter-font-family);
      font-size: var(--typewriter-font-size);
      font-weight: var(--typewriter-font-weight);
      background-color: var(--typewriter-background-color);
      background: var(--typewriter-background);
      text-transform: var(--typewriter-text-transform);
    }

    .withCursor::after {
      content: var(--typewriter-cursor, "▮");
      font-size: var(--typewriter-cursor-font-size);
      color: var(--typewriter-cursor-color);
      animation-name: var(--typewriter-cursor-animation-name, blink);
      animation-duration: var(--typewriter-cursor-animation-speed, 0.5s);
      animation-timing-function: var(
        --typewriter-cursor-animation-easing,
        cubic-bezier(0.4, 0, 0.2, 1)
      );
      animation-iteration-count: infinite;
    }

    .withCursor.isTyping::after {
      animation: none;
    }

    @keyframes blink {
      0% {
        opacity: 0;
      }
      50% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
  `;
    })();
    connectedCallback() {
        super.connectedCallback();
        this._type();
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<span
      dir="${this._getDirection()}"
      class=${(0, $0e5c059fc79abe53$export$56cc687933817664)({
            text: true,
            withCursor: !this.noCursor,
            isTyping: this.isTyping
        })}
      >${this.typedText}</span
    >`;
    }
    constructor(...args){
        super(...args);
        /**
   * Array of strings to display.
   */ this.strings = [
            "Hello World!",
            "I'm a Typewriter."
        ];
        /**
   * Defines whether to show the cursor or not.
   * Default: true
   */ this.noCursor = false;
        /**
   * Delay after typing a character, in milliseconds.
   * Default: 100
   */ this.typingDelay = 100;
        /**
   * Delay after erasing a character, in milliseconds.
   * Default: 17
   */ this.erasingDelay = 17;
        /**
   * Delay after typing a string, in milliseconds.
   * Default: 1000
   */ this.delayAfterTyping = 1000;
        /**
   * Delay after erasing a string, in milliseconds.
   * Default: 500
   */ this.delayAfterErasing = 500;
        /**
   * Defines whether typing should have a natural effect.
   * When set to true, the typing delay will be multiplied
   * by a random number between 0.5 and 1.5, resulting in a
   * more natural typing effect.
   * Default: false.
   */ this.natural = false;
        /**
   * Array of indices of strings that should be typed right-to-left.
   * Default: []
   */ this.rtlStringIndices = [];
        this.typedText = "";
        this.currentStringIndex = 0;
        this.isTyping = false;
        this._type = ()=>{
            const currentString = this.strings[this.currentStringIndex];
            if (this.typedText.length < currentString.length) {
                this.isTyping = true;
                this.typedText += currentString[this.typedText.length];
                const delay = this.natural ? Math.max((Math.random() + 0.5) * this.typingDelay, 17) : this.typingDelay;
                setTimeout(this._type, delay);
            } else {
                this.isTyping = false;
                setTimeout(this._erase, this.delayAfterTyping);
            }
        };
        this._erase = ()=>{
            if (this.erasingDelay === 0) {
                this.typedText = "";
                this.currentStringIndex = ++this.currentStringIndex % this.strings.length;
                setTimeout(this._type, this.delayAfterErasing + this.typingDelay);
            } else if (this.typedText.length > 0) {
                this.isTyping = true;
                this.typedText = this.typedText.slice(0, this.typedText.length - 1);
                setTimeout(this._erase, this.erasingDelay);
            } else {
                this.isTyping = false;
                this.currentStringIndex = ++this.currentStringIndex % this.strings.length;
                setTimeout(this._type, this.delayAfterErasing + this.typingDelay);
            }
        };
        this._getDirection = ()=>this.rtlStringIndices.indexOf(this.currentStringIndex) > -1 ? "rtl" : "ltr";
    }
};
(0, $7f1ab97a393746d0$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Array,
        reflect: true
    })
], $e91f56086727f83c$export$148c46df640f7a93.prototype, "strings", void 0);
(0, $7f1ab97a393746d0$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $e91f56086727f83c$export$148c46df640f7a93.prototype, "noCursor", void 0);
(0, $7f1ab97a393746d0$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $e91f56086727f83c$export$148c46df640f7a93.prototype, "typingDelay", void 0);
(0, $7f1ab97a393746d0$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $e91f56086727f83c$export$148c46df640f7a93.prototype, "erasingDelay", void 0);
(0, $7f1ab97a393746d0$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $e91f56086727f83c$export$148c46df640f7a93.prototype, "delayAfterTyping", void 0);
(0, $7f1ab97a393746d0$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $e91f56086727f83c$export$148c46df640f7a93.prototype, "delayAfterErasing", void 0);
(0, $7f1ab97a393746d0$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $e91f56086727f83c$export$148c46df640f7a93.prototype, "natural", void 0);
(0, $7f1ab97a393746d0$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Array
    })
], $e91f56086727f83c$export$148c46df640f7a93.prototype, "rtlStringIndices", void 0);
(0, $7f1ab97a393746d0$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $e91f56086727f83c$export$148c46df640f7a93.prototype, "typedText", void 0);
(0, $7f1ab97a393746d0$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $e91f56086727f83c$export$148c46df640f7a93.prototype, "isTyping", void 0);
$e91f56086727f83c$export$148c46df640f7a93 = (0, $7f1ab97a393746d0$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("lit-typewriter")
], $e91f56086727f83c$export$148c46df640f7a93);



document.addEventListener("mousemove", (event)=>{
    const x = event.pageX;
    const y = event.pageY;
    $ad2bcec7a0192558$var$updateGradient(x, y);
});
document.addEventListener("touchmove", (event)=>{
    const x = event.touches[event.touches.length - 1].clientX;
    const y = event.touches[event.touches.length - 1].clientY;
    $ad2bcec7a0192558$var$updateGradient(x, y);
});
const $ad2bcec7a0192558$var$updateGradient = (x, y)=>{
    const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    const pctX = Math.round(x / vw * 100);
    const pctY = Math.round(y / vh * 100);
    document.body.style.backgroundImage = `
        radial-gradient(at ${pctX}% ${pctY}%, #d76d77, #5c3a70)
    `;
};


//# sourceMappingURL=index.a58ed155.js.map
